import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, unref as _unref, withCtx as _withCtx, createBlock as _createBlock, createVNode as _createVNode } from "vue"

import { IonSelect, IonSelectOption, IonItem } from '@ionic/vue';

interface Props {
  ariaLabel: string;
  modelValue: unknown;
  elements: (string | { label: string; value: string; })[];
  translateElements?: boolean;
  placeholder?: string;
  label?: string;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'BasicNormalSelect',
  props: {
    ariaLabel: null,
    modelValue: null,
    elements: null,
    translateElements: { type: Boolean },
    placeholder: null,
    label: null
  },
  emits: ['update:modelValue'],
  setup(__props: any, { emit }) {

const props = __props as {
  ariaLabel: string;
  modelValue: unknown;
  elements: (string | { label: string; value: string; })[];
  translateElements?: boolean;
  placeholder?: string;
  label?: string;
};




return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(IonItem), { class: "select__outer" }, {
    default: _withCtx(() => [
      _createVNode(_unref(IonSelect), {
        class: "basic__select",
        "aria-label": props.ariaLabel,
        placeholder: props.placeholder,
        value: props.modelValue,
        onIonChange: _cache[0] || (_cache[0] = ($event) => emit('update:modelValue', $event.detail.value))
      }, {
        default: _withCtx(() => [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(props.elements, (element) => {
            return (_openBlock(), _createBlock(_unref(IonSelectOption), {
              value: typeof element === 'string' ? element : element.value,
              key: typeof element === 'string' ? element : element.value
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(__props.translateElements ? _ctx.$t(`label.${(typeof element === 'string' ? element : element.label)}`) : ((typeof element === 'string' ? element : element.label))), 1)
              ]),
              _: 2
            }, 1032, ["value"]))
          }), 128))
        ]),
        _: 1
      }, 8, ["aria-label", "placeholder", "value"])
    ]),
    _: 1
  }))
}
}

})